import { createSelector } from "@reduxjs/toolkit";

import { IUserAttributes } from "Auth/types";
import { API_ENDPOINTS } from "shared/constants";
import { buildSingleItem } from "shared/utils";
import { dataSelector } from "../helpers";

const dataUserSelector = createSelector(dataSelector, data => data.user);

export const userSelectorCreator = (id: string) =>
  createSelector(dataUserSelector, users => {
    const user = users?.[API_ENDPOINTS.USER(id)];
    if (user) {
      return buildSingleItem(user) as IUserAttributes;
    }
    return null;
  });
